import React from 'react';
import { Link } from 'react-router-dom';
import PageTemplate from '../components/PageTemplate';

const Services = () => {
  const serviceCategories = [
    {
      title: "Team Augmentation",
      description: "Scale your team with dedicated professionals who integrate seamlessly with your existing workforce.",
      icon: "fas fa-users",
      link: "/services/team-augmentation",
      features: ["Dedicated Teams", "CTO as a Service", "Technology Specialists", "Long-term Partnerships"]
    },
    {
      title: "IT Consulting",
      description: "Strategic guidance to optimize your technology infrastructure and drive digital transformation.",
      icon: "fas fa-chart-line",
      link: "/services/it-consulting",
      features: ["Technology Consulting", "Digital Transformation", "Legacy Modernization", "Architecture Design"]
    },
    {
      title: "Cloud Services",
      description: "Comprehensive cloud solutions to enhance scalability, security, and operational efficiency.",
      icon: "fas fa-cloud",
      link: "/services/cloud-services",
      features: ["Cloud Migration", "Cloud Consulting", "SaaS Development", "Multi-Cloud Strategy"]
    },
    {
      title: "DevOps & Automation",
      description: "Streamline your development lifecycle with advanced DevOps practices and automation.",
      icon: "fas fa-cogs",
      link: "/services/devops",
      features: ["CI/CD Pipeline", "Infrastructure as Code", "Kubernetes", "Monitoring & Logging"]
    }
  ];

  const applicationServices = [
    {
      title: "Website Development",
      description: "Modern, responsive websites built with the latest technologies for optimal performance.",
      icon: "fas fa-globe",
      link: "/applications/website-development"
    },
    {
      title: "Mobile Development",
      description: "Native and cross-platform mobile applications for iOS, Android, and hybrid platforms.",
      icon: "fas fa-mobile-alt",
      link: "/applications/mobile-development"
    },
    {
      title: "Game Development",
      description: "Immersive gaming experiences including AR, VR, and metaverse applications.",
      icon: "fas fa-gamepad",
      link: "/applications/game-development"
    },
    {
      title: "Quality Assurance",
      description: "Comprehensive testing services to ensure software quality and reliability.",
      icon: "fas fa-check-circle",
      link: "/applications/quality-assurance"
    },
    {
      title: "UI/UX Design",
      description: "User-centered design solutions that create engaging and intuitive experiences.",
      icon: "fas fa-paint-brush",
      link: "/applications/ui-ux-design"
    }
  ];

  return (
    <PageTemplate
      title="Our Services"
      subtitle="Comprehensive technology solutions to drive your business forward"
      breadcrumb="Services"
    >
      <div className="content-section">
        <h2>Core Services</h2>
        <div className="content-grid">
          {serviceCategories.map((service, index) => (
            <div key={index} className="content-card">
              <div className="icon">
                <i className={service.icon}></i>
              </div>
              <h4>{service.title}</h4>
              <p>{service.description}</p>
              <ul className="feature-list">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <Link to={service.link} className="btn btn-outline">
                Learn More
              </Link>
            </div>
          ))}
        </div>
      </div>

      <div className="content-section">
        <h2>Application Development</h2>
        <div className="content-grid">
          {applicationServices.map((service, index) => (
            <div key={index} className="content-card">
              <div className="icon">
                <i className={service.icon}></i>
              </div>
              <h4>{service.title}</h4>
              <p>{service.description}</p>
              <Link to={service.link} className="btn btn-outline">
                Explore
              </Link>
            </div>
          ))}
        </div>
      </div>

      <div className="content-section">
        <h2>Specialized Solutions</h2>
        <div className="content-grid">
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-robot"></i>
            </div>
            <h4>AI & Data Solutions</h4>
            <p>Advanced artificial intelligence and data engineering services to unlock business insights.</p>
            <Link to="/ai-data" className="btn btn-outline">
              Discover AI Solutions
            </Link>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-microchip"></i>
            </div>
            <h4>Engineering Services</h4>
            <p>Embedded systems, IoT development, and advanced engineering solutions for complex projects.</p>
            <Link to="/engineering" className="btn btn-outline">
              View Engineering
            </Link>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-industry"></i>
            </div>
            <h4>Industry Solutions</h4>
            <p>Specialized solutions tailored for specific industries including healthcare, finance, and retail.</p>
            <Link to="/industries" className="btn btn-outline">
              Industry Focus
            </Link>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <h3>Ready to Get Started?</h3>
        <p>Contact us today to discuss your project requirements and see how we can help.</p>
        <Link to="/contact" className="btn btn-primary">
          Start Your Project
        </Link>
      </div>
    </PageTemplate>
  );
};

export default Services; 